import React, { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { filter, size, map, get } from 'lodash'
import { useHistory, useParams } from "react-router-dom"
import { showSuccess, showError } from '../v2_actions/error'
import { confirmModal } from '../v2_actions/ui'
import Gallery from "react-photo-gallery"
import { PhotoArtGalleries } from './PhotoArtGalleries'
import { PageLayout } from './layout/PageLayout'
import { makeStyles } from "@material-ui/core"
import { photographList } from '../v2_actions/photograph'
import { galleryList } from '../v2_actions/gallery'

const ROW_HEIGHT = "200px"

const useStyles = makeStyles({
    photo_art_galleries_container: {
        display: "flex",
        flexWrap: "wrap",
        height: ROW_HEIGHT
    },
    photo_art_gallery_container: {
        margin: "10px",
        position: "relative",
        height: ROW_HEIGHT,
        backgroundColor: "lightgray"
    },
    photograph: {
        height: ROW_HEIGHT
    },
    gallerySpecificAction: {
        display: "flex",
        alignItems: "center"
    }
    
})

export const PhotoArtGalleryView = () => {
    const galleries = useSelector(() => galleryList.getVisibleObjects())
    const photo_art_galleries = filter(galleries, (gallery) => gallery.gallery_type === "photo_art")
    const classes = useStyles()
    const history = useHistory()
    const dispatch = useDispatch()

    const onEditPhotoArtGallery = (photograph) => {
        const photo_art_gallery_id = get(photograph, "gallery")
        history.push(`/photographer/gallery/${photo_art_gallery_id}`)
    }

    const onDeletePhotoArtGallery = (photograph) => {
        const gallery_id = get(photograph, "gallery")
        const gallery = galleryList.getObject(gallery_id)

        const onDeleted = (json) => {
            if ( json.errors ) {
                showError("Error", JSON.stringify(json.errors))
            } else {
                dispatch(galleryList.invalidateList())
                dispatch(galleryList.fetchListIfNeeded())
                showSuccess("Removed", "Removed image from Photo Art gallery")
            }
        }

        const onConfirmed = () => {
            const values = Object.assign({}, gallery, {available_to_purchase: false})
            dispatch(galleryList.saveObject(values)).then(onDeleted)
        }
        
        dispatch(confirmModal({text: "Are you sure you want to make this photo unavailable to purchase?",
                               onConfirmed: onConfirmed,
                               can_cancel: true}))
        
    }

    const imageRenderer = useCallback( function({ photo }) {
        return (
            <>
                <PhotoArtGalleries
                    onDeletePhotoArtGallery={onDeletePhotoArtGallery}
                    onEditPhotoArtGallery={onEditPhotoArtGallery}
                    photo={photo}
                />
            </>
        )
    }, [])
    
    return (
        <PageLayout title={"Photo Art Gallery"}>
          <div className={classes.photo_art_galleries_container}>
              {map(photo_art_galleries, (gallery) => (
                  get(gallery, "photographs") &&
                    <>
                        <Gallery photos={gallery.photographs} renderImage={imageRenderer} />
                    </>
               ))}
            { size(photo_art_galleries) === 0 &&
              <div>There are no photoart photographs</div>
            }
          </div>
        </PageLayout>
    )   
}
